import biLogger from '@wix/web-bi-logger';
import { BI_UOU_ENDPOINT, BI_UOU_SRC } from '@wix/communities-blog-client-common';
import { blogAppDefId } from '@app/external/common/constants/apps';

/**
 * Instantiating `@wix/web-bi-logger` instead of using `useBi` by `@wix/yoshi-flow-editor`.
 *
 * Reason: navigator.sendBeacon() must be used to send bi events when "beforeunload" event fires - other methods don't work.
 * Yoshi's `useBi` hook sends BI events with fetch, which are skipped when is closed.
 **/
export const biWithBeaconSupport = biLogger
  .factory({ endpoint: BI_UOU_ENDPOINT })
  .updateDefaults({
    src: BI_UOU_SRC,
    app_id: blogAppDefId,
  })
  .logger();
